import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clinics: [],
  selectedClinic: null,
  loading: false,
  error: null,
};

const clinicsSlice = createSlice({
  name: 'clinics',
  initialState,
  reducers: {
    // Set clinics list
    setClinics: (state, action) => {
      state.clinics = action.payload;
    },

    // Set selected clinic
    setSelectedClinic: (state, action) => {
      state.selectedClinic = action.payload;
    },

    // Add clinic to list
    addClinicToList: (state, action) => {
      state.clinics.push(action.payload);
    },

    // Update clinic in list
    updateClinicInList: (state, action) => {
      const index = state.clinics.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.clinics[index] = action.payload;
      }
      if (state.selectedClinic?.id === action.payload.id) {
        state.selectedClinic = action.payload;
      }
    },

    // Remove clinic from list
    removeClinicFromList: (state, action) => {
      state.clinics = state.clinics.filter((c) => c.id !== action.payload);
      if (state.selectedClinic?.id === action.payload) {
        state.selectedClinic = null;
      }
    },

    // Set loading
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error
    setError: (state, action) => {
      state.error = action.payload;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Reset state
    resetClinics: () => initialState,
  },
});

export const {
  setClinics,
  setSelectedClinic,
  addClinicToList,
  updateClinicInList,
  removeClinicFromList,
  setLoading,
  setError,
  clearError,
  resetClinics,
} = clinicsSlice.actions;

export default clinicsSlice.reducer;